import {createSlice} from "@reduxjs/toolkit";

export const skipassSlice = createSlice({
    name: "skipassesList",
    initialState: {
        value: [],
    },
    reducers: {
        setSkipasses: (state, action) => {
            state.value = action.payload;
        },
        addSkipass: (state) => {
            state.value.push(
                {
                    title: null,
                    type: null,
                    validity: null,
                    prices: [0, 0, 0, 0]
                },
            );
        },
        removeSkipassByIdx: (state, action) => {
            const indexToRemove = action.payload;
            if (indexToRemove >= 0 && indexToRemove < state.value.length) {
                state.value.splice(indexToRemove, 1);
            }
        },
        updateSkipassByIdx: (state, action) => {
            const {index, newObject} = action.payload;
            if (index >= 0 && index < state.value.length) {
                state.value[index] = newObject;
            }
        },
    },
});

export const {
    setSkipasses,
    addSkipass,
    removeSkipassByIdx,
    updateSkipassByIdx
} = skipassSlice.actions;

export default skipassSlice.reducer;


